/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StoreGlobalMessageTemplateRequest = {
    /**
     * The name of the global message template.
     */
    name?: string
    /**
     * The category of the global message template.
     */
    category?: string
    /**
     * The from email of the global message template.
     */
    from?: string
    /**
     * The reply to email of the global message template.
     */
    reply_to?: string | null
    /**
     * The subject of the global message template.
     */
    subject?: string
    /**
     * Content of the global message template.
     */
    content?: Record<string, any>
    /**
     * Type of the global message template.
     */
    type?: StoreGlobalMessageTemplateRequest.type
}

export namespace StoreGlobalMessageTemplateRequest {
    /**
     * Type of the global message template.
     */
    export enum type {
        UNLAYER = 'unlayer',
        SMS = 'sms',
        HTML = 'html'
    }
}
